<template>
  <Modal
    class="common-drawer newModal"
    v-model="isShow"
    class-name="constabook"
    :title="title"
    width="480px"
    :mask-closable="false"
    @on-cancel="closeModal"
  >
    <Form
      ref="versionFormValidate"
      :model="versionFromData"
      label-position="top"
      :rules="versionRuleValidate"
    >
      <FormItem prop="code" label="版本号">
        <Input
          v-model="versionFromData.code"
          type="text"
          maxlength="20"
          placeholder="请输入"
        ></Input>
      </FormItem>
      <FormItem label="版本更新内容" prop="content">
        <Input
          v-model="versionFromData.content"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
          maxlength="100"
          show-word-limit
          placeholder="请输入"
        ></Input>
      </FormItem>
      <FormItem label="版本更新时间" prop="gmtRealCreate">
        <!--:value="versionFromData.gmtRealCreate"  -->
        <DatePicker
         
          v-model="versionFromData.gmtRealCreate"
          style="width: 100%"
          @on-change="changeDate"
          format="yyyy-MM-dd"
          type="date"
          placeholder="请选择"
        ></DatePicker>
      </FormItem>
    </Form>
    <div class="drawer-footer" slot="footer">
      <Button type="primary" @click="submit()" :loading="btnLoading"
        >提交</Button
      >
      <Button style="margin-left: 8px" @click="closeModal()">取消</Button>
    </div>
  </Modal>
</template>
<script>
import api from "@/api";
import sizeData from "@/mixins/sizeData";
import handleSelItem from "@/mixins/handleSelItem";
import toRoleName from "@/mixins/roleName";
import ls from "store2";

import moment from "moment";
import { validateVersion } from "@/util/validate";

export default {
  props: ["showModal", "title", "editData"],
  mixins: [handleSelItem, sizeData, toRoleName],
  watch: {
    showModal: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$refs.versionFormValidate.resetFields();
          this.isShow = newValue;
          if (this.title.indexOf("编辑") > -1) {
          
            this.versionFromData = {
              id: this.editData.id,
              code: this.editData.code,
              content: this.editData.content,
              gmtRealCreate: this.editData.gmtRealCreate,
            };
            this.changeDate(this.editData.gmtRealCreate);
          } else {
            this.versionFromData = {};
          }
        }
      },
      deep: true,
    },
  },
  data() {
    const validateid = function (rule, value, callback) {
   
      let gmtRealCreate = this.formData.gmtRealCreate;

      if (value === "") {
      
        callback(new Error("请选择时间"));
      } else {
      
        callback();
      }
    };

    // 校验  验证 版本号
    const validateversion = (rule, value, callback) => {
      if (validateVersion(value)) {
        callback(new Error('请正确填写版本号'));
      } else {
        callback();
      }
    };

    return {
      isShow: false,
      versionFromData: {
        code: "",
        content: "",
        gmtRealCreate: "",
      },
      versionRuleValidate: {
        code: [
          {
            required: true,
            type: "string",
            message: "请输入版本号",
            trigger: "blur",
          },
          {
            message: "请输入正确的版本号",
            trigger: "blur",
            validator: validateversion,
          },
          {
            message: "请输入正确的版本号",
            trigger: "change",
            validator: validateversion,
          },
        ],
        content: [
          {
            required: true,
            type: "string",
            message: "请输入版本更新内容",
            trigger: "blur",
          },
          {
            type: "string",
            max: 100,
            message: "最多输入100字符",
            trigger: "blur",
          },
        ],
        gmtRealCreate: [
          {
            required: true,
            // type: "date",
            message: "请选择时间",
            // trigger: "change",
          },
        
        ],
      },
      btnLoading: false,
    };
  },
  mounted() {},
  methods: {
    submit() {
      this.$refs.versionFormValidate.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          if (this.title.indexOf("编辑") > -1) {
            this.edit();
          } else {
            this.add();
          }
        }
      });
    },
    add() {
      this.versionFromData.gmtRealCreate= this.$moment(this.versionFromData.gmtRealCreate).format('YYYY-MM-DD')
      api
        .axss(
          "post",
          "/ocm-oil-site/oil-site-publish-version/add",
          this.versionFromData
        )
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("新增成功");
            this.$emit("success");
            this.btnLoading = false;
          }
        })
        .catch((error) => {
          this.btnLoading = false;
        });
    },
    edit() {
         this.versionFromData.gmtRealCreate= this.$moment(this.versionFromData.gmtRealCreate).format('YYYY-MM-DD')
      api
        .axss(
          "post",
          "/ocm-oil-site/oil-site-publish-version/edit",
          this.versionFromData
        )
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("编辑成功");
            this.$emit("success");
            this.btnLoading = false;
          }
        })
        .catch((error) => {
          this.btnLoading = false;
        });
    },
    changeDate(e) {
      this.versionFromData.gmtRealCreate = moment(e).format("yyyy-MM-DD");
     
    },
    closeModal() {
      this.$emit("close");
      this.isShow = false;
    },
  },
};
</script>
  <style>
.dataExportDrawer .ivu-btn.ivu-btn-primary {
  color: #fff !important;
  background-color: #0c479d !important;
  border-color: #0c479d !important;
  padding: 0 7px !important;
}

.constabook .ivu-btn-primary {
  color: #fff;
  background-color: #0c479d;
  border-color: #0c479d;
}
.constabook .ivu-btn-small {
}
.constabook .ivu-btn-small {
  padding: 0 7px !important;
}
</style>